/** Simple filter FUNCTION
 * @param {Array.<string|number>} list - List of filtered values.
 * @param {Object} exp - Filter expresion.
 * PREDICATE: isNotEqual = 0, isEqual = 1
 * OPERATION: or = 0, and = 1
 * PR, PR-VAL, OP, PR, PR-VAL, OP, ...
 * @returns {boolean}
 */
export default (list, exp) => {
  let subRes = []
  for (let i = 0; i < exp.count; i++) {
    const fVal = exp[i][1].toString().startsWith('sfid') ? '' : exp[i][1]
    const sfVal = !fVal ? exp[i][1].charAt(4) : '' // a = any, n = non
    let ok = false
    if (!exp[i][0]) { // rovná se
      if (sfVal) {
        if (sfVal === 'a') {
          if (list[0]) {
            ok = true
          }
        } else {
          if (!list[0]) {
            ok = true
          }
        }
      } else {
        for (let j = 0; j < list.length; j++) {
          if (list[j] === exp[i][1]) {
            ok = true
            break
          }
        }
      }
    // nerovná se
    } else if (sfVal) {
        if (sfVal === 'a') {
          if (!list[0]) {
            ok = true
          }
        } else {
          if (list[0]) {
            ok = true
          }
        }
      } else {
      for (let j = 0; j < list.length; j++) {
        ok = true
        if (list[j] === exp[i][1]) {
          ok = false
          break
        }
      }
    }
    subRes.push(ok)
  }

  if (exp.count === 1) {
    return subRes[0]
  }

  for (let i = 1; i < exp.count; i++) {
    if (!exp[i - 1][2]) { // a
      if (!subRes[i - 1] || !subRes[i]) {
        return false
      }
    } else { // nebo
      if (!subRes[i - 1] && !subRes[i]) {
        return false
      }
    }
  }

  return true
}



// WEBPACK FOOTER //
// ./src/utils/jskFilter.js